import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Type: ")
const _hoisted_5 = { class: "inline-block bg-yellow-200" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 w-full bg-black text-white" }, "Config:", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 w-full bg-black text-white" }, "Funds:", -1)
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "mb-2" }
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 w-full bg-black text-white" }, "Times:", -1)
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = { class: "mb-2" }
const _hoisted_22 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FixedScheduleDisplay = _resolveComponent("FixedScheduleDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.parseRewardType(_ctx.reward)), 1)
    ]),
    _createElementVNode("div", _hoisted_6, "Mint: " + _toDisplayString(_ctx.parseRewardMint(_ctx.reward)), 1),
    _hoisted_7,
    (_ctx.parseRewardType(_ctx.reward) === 'variable')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, " Reward rate: " + _toDisplayString(_ctx.numeral(_ctx.reward.variableRate.rewardRate.n / 10 ** 15).format('0,0.0')) + " tokens/s ", 1),
          _createElementVNode("div", _hoisted_10, " Accrued reward/gem: " + _toDisplayString(_ctx.numeral(_ctx.reward.variableRate.accruedRewardPerRarityPoint.n / 10 ** 15).format(
            '0,0.0'
          )), 1),
          _createElementVNode("div", _hoisted_11, " Reward last updated: " + _toDisplayString(_ctx.parseDate(_ctx.reward.variableRate.rewardLastUpdatedTs)), 1),
          _hoisted_12
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createTextVNode(" Reserved amount: " + _toDisplayString(_ctx.reward.fixedRate.reservedAmount) + " ", 1),
            _createVNode(_component_FixedScheduleDisplay, {
              schedule: _ctx.reward.fixedRate.schedule
            }, null, 8, ["schedule"])
          ])
        ])),
    _hoisted_15,
    _createElementVNode("div", _hoisted_16, "Funded: " + _toDisplayString(_ctx.reward.funds.totalFunded), 1),
    _createElementVNode("div", _hoisted_17, "Refunded: " + _toDisplayString(_ctx.reward.funds.totalRefunded), 1),
    _createElementVNode("div", _hoisted_18, "Accrued: " + _toDisplayString(_ctx.reward.funds.totalAccruedToStakers), 1),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, "Duration: " + _toDisplayString(_ctx.reward.times.durationSec) + " sec", 1),
    _createElementVNode("div", _hoisted_21, " Reward end: " + _toDisplayString(_ctx.parseDate(_ctx.reward.times.rewardEndTs)), 1),
    _createElementVNode("div", _hoisted_22, "Lock end: " + _toDisplayString(_ctx.parseDate(_ctx.reward.times.lockEndTs)), 1)
  ]))
}